import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";

const QuestionsTable = ({ data }) => {
  return (
    <View style={styles.table}>
      {/* Table Header */}
      <View style={styles.tableHeader}>
        <View style={styles.elipse} />
        <Text style={[styles.headerCell, styles.factorColumn]}>Question</Text>
        <Text style={[styles.headerCell, styles.scoreColumn]}>Score</Text>
        <Text style={[styles.headerCell, styles.normColumn]}>Norm</Text>
        <Text style={[styles.headerCell, styles.changeColumn]}>Change</Text>
      </View>

      {/* Table Rows */}
      {data.map((row, index) => (
        <View
          key={index}
          style={[
            styles.tableRow,
            index % 2 === 0 ? styles.oddRow : styles.evenRow,
            //   If its the last row in the table, add a border radius to the bottom
            index === data.length - 1
              ? { borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
              : {},
          ]}
        >
          <Text style={[styles.cell, styles.factorColumn]}>{row.question}</Text>
          <Text style={[styles.cell, styles.scoreColumn]}>{row.score}%</Text>
          <Text style={[styles.cell, styles.normColumn]}>
            {(row.normAverage && `${(row.normAverage * 10).toFixed(1)}%`) ||
              "--"}
          </Text>
          <Text
            style={[
              styles.cell,
              styles.changeColumn,
              row?.change?.includes("--")
                ? styles.noColorChange
                : row.change === "0%"
                ? styles.neutralChange
                : row?.change?.includes("-")
                ? styles.negativeChange
                : styles.positiveChange,
            ]}
          >
            {row?.change}
          </Text>
        </View>
      ))}
    </View>
  );
};

// Styles for the Table
const styles = StyleSheet.create({
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#EBF1FD",
    borderRadius: 9,
    overflow: "hidden",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#fff",
    padding: 10,
    borderTopLeftRadius: 9,
    borderTopRightRadius: 9,
  },
  elipse: {
    width: 5,
    height: 5,
    borderRadius: 5,
    marginRight: 5,
    top: 3,
    backgroundColor: "#2D70E2",
  },
  factorElipseWrap: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerCell: {
    fontSize: 10,
    fontFamily: "Raleway",
    fontWeight: 600,
    color: "#666D79",
  },
  factorColumn: {
    flex: 3,
  },
  scoreColumn: {
    flex: 1,
    textAlign: "center",
    marginRight: 3,
  },
  normColumn: {
    flex: 1,
    textAlign: "center",
  },
  changeColumn: {
    flex: 1,
    textAlign: "center",
  },
  tableRow: {
    flexDirection: "row",
    padding: 10,
  },
  evenRow: {
    backgroundColor: "#FFFFFF",
  },
  oddRow: {
    backgroundColor: "#F3F8FF",
  },
  cell: {
    fontSize: 12,
    color: "#2A3039",
    fontFamily: "Raleway",
    fontWeight: 600,
  },
  positiveChange: {
    color: "#1D9A7D", // Secondary/600
  },
  negativeChange: {
    color: "#E34D59", // Example negative change color
  },
  neutralChange: {
    color: "#F5A623", // Example neutral (0%) color
  },
  noColorChange: {
    color: "#2A3039",
  },
});

export default QuestionsTable;
